exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".Stories-module__stories___3rCSH{display:flex;gap:32px;flex-wrap:wrap-reverse;flex-direction:row}.Stories-module__stories___3rCSH .Stories-module__video___3PyLE{flex:1;aspect-ratio:16/9;width:100%;background-color:#e8f7fc;border-radius:26px;min-width:240px}", ""]);

// exports
exports.locals = {
	"stories": "Stories-module__stories___3rCSH",
	"video": "Stories-module__video___3PyLE"
};